var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"se-main"},[_c('iframe',{attrs:{"src":_vm.url,"width":"100%","height":"100%","border":"0"}}),_c('div',{staticClass:"se-btn"},[_c('el-button',{attrs:{"type":"danger"},on:{"click":_vm.downLoadFile}},[_vm._v("下载文件")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }